import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { readRecentlyViewed } from './recentlyViewed';

interface ProductCard {
  id: number;
  name: string;
  slug: string;
  price: number;
  thumbnail: string | null;
}

interface Props {
  excludeId?: number;
  title?: string;
}

const RecentlyViewed: React.FC<Props> = ({ excludeId, title = 'Nedávno prohlížené' }) => {
  const [items, setItems] = useState<ProductCard[]>([]);

  useEffect(() => {
    const ids = readRecentlyViewed().filter((id) => id !== excludeId);
    if (ids.length === 0) { setItems([]); return; }
    fetch(`/api/products-by-ids?ids=${ids.join(',')}`)
      .then((r) => r.json())
      .then((d) => setItems(d.data || []))
      .catch(() => setItems([]));
  }, [excludeId]);

  if (items.length === 0) return null;

  return (
    <section className="pd-recently">
      <h3 className="pd-recently__title">{title}</h3>
      <div className="pd-recently__grid">
        {items.map((p) => (
          <Link key={p.id} to={`/product/${p.slug}`} className="pd-recently__item">
            <div className="pd-recently__img">
              <img src={p.thumbnail || '/img/img_placeholder.jpg'} alt={p.name} loading="lazy" />
            </div>
            <div className="pd-recently__name">{p.name}</div>
            <div className="pd-recently__price">{Math.round(p.price).toLocaleString('cs-CZ')} Kč</div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RecentlyViewed;
